import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import transition from "~/utilities/transition";

const StyledCADIcon = styled.div`
    ${transition({}, "fill")};
    fill: ${({ theme }) => theme.colors.typography.links};
    width: 0.75em;
    display: flex;
    margin-right: ${({ withTitle }) => (withTitle ? `10px` : `0`)};

    &:hover,
    &:focus {
        fill: ${({ theme }) => theme.colors.typography.linksHover};
    }

    svg {
        max-height: 30px;
    }
`;

const CADIcon = ({ withTitle = false }) => (
    <StyledCADIcon {...{ withTitle }}>
        <svg
            aria-hidden="true"
            focusable="false"
            className="svg-inline--fa"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 384 512"
        >
            <path
                d="M224 0v128c0 17.7 14.3 32 32 32h128v288c0 35.3-28.7 64-64 64H64c-35.35 0-64-28.7-64-64V64C0 28.65 28.65 0 64 0h160ZM89 224H73c-22.09 0-40 17.9-40 40v80c0 22.1 17.91 40 40 40h16c22.1 0 40-17.9 40-40v-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 4.4-3.6 8-8 8H73c-4.42 0-8-3.6-8-8v-80c0-4.4 3.58-8 8-8h16c4.4 0 8 3.6 8 8v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-22.1-17.9-40-40-40Zm105.194-.052c-5.4 0-10.3 2.7-13.3 7.1l-5.677 8.569a175.832 175.832 0 0 0-29.023 96.731v31.6l.003.314c.168 8.657 7.301 15.686 15.997 15.686 8.8 0 16-7.2 16-16v-31.6l.01-1.679c.025-2.237.103-4.47.233-6.697h31.513c.162 2.784.244 5.577.244 8.376v31.6l.003.314c.168 8.657 7.301 15.686 15.997 15.686 8.8 0 16-7.2 16-16v-31.6l-.004-1.04a175.834 175.834 0 0 0-29.596-96.56l-5.1-7.7-.208-.297c-3.015-4.224-7.815-6.803-13.092-6.803Zm0 46.5a142.89 142.89 0 0 1 10.22 25.523h-20.441a142.89 142.89 0 0 1 10.22-25.523ZM298 256h8c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-8v-96Zm-32 112c0 8.8 7.2 16 16 16h24c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-24c-8.8 0-16 7.2-16 16v128ZM256 0l128 128H256V0Z"
                fill="currentColor"
                fillRule="nonzero"
            />
        </svg>
    </StyledCADIcon>
);

CADIcon.propTypes = {
    withTitle: PropTypes.bool,
};

export default CADIcon;
